import { render } from "./SiteNavTemplate.vue?vue&type=template&id=43a657d6&ts=true"
import script from "./SiteNavTemplate.vue?vue&type=script&lang=ts"
export * from "./SiteNavTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__